<!--IMMO IP NAV BUTTON-->
<div class="d-flex">
  <div>
    <button
      [ngClass]="
        selectedOverview === 'new'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('new')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'new' ? 'border-badge-selected' : 'border-badge'
        "
        matBadge="{{ countNew }}"
        [matBadgeHidden]="countNew == null || countNew === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Nieuwe
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'design'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('design')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'design'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countDesign }}"
        [matBadgeHidden]="countDesign == null || countDesign === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Ontwerp
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'print'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('print')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'print'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countPrint }}"
        [matBadgeHidden]="countPrint == null || countPrint === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Printwerk
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'appointment'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('appointment')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'appointment'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countAppointment }}"
        [matBadgeHidden]="countAppointment == null || countAppointment === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Afspraak
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'tour'
          ? 'tour-selected-button'
          : 'tour-non-selected-button'
      "
      (click)="changeSelectedView('tour')"
      type="button"
      mat-button
    >
      Toeren
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'atelier'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('atelier')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'atelier'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countAtelier }}"
        [matBadgeHidden]="countAtelier == null || countAtelier === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Atelier
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'non-executed'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge-red'
      "
      (click)="changeSelectedView('non-executed')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'non-executed'
            ? 'border-badge-selected'
            : 'border-badge-red'
        "
        matBadge="{{ countNonExecuted }}"
        [matBadgeHidden]="countNonExecuted == null || countNonExecuted === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Niet uitgevoerd
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'billing'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('billing')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'billing'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countBilling }}"
        [matBadgeHidden]="countBilling == null || countBilling === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Facturatie
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'completed'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('completed')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'completed'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countCompleted }}"
        [matBadgeHidden]="countCompleted == null || countCompleted === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Uitgevoerde
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'tasks'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('tasks')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'tasks'
            ? 'border-badge-selected'
            : 'border-badge'
        "
      ></span>
      Taken
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'overview'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('overview')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'overview'
            ? 'border-badge-selected'
            : 'border-badge'
        "
      ></span>
      Overzicht
    </button>
  </div>
</div>

<!--INTERACT BUTTONS-->
<div class="position-absolute">
  <button
    *ngIf="selectedOverview === 'new'"
    mat-flat-button
    class="action-button"
    [routerLink]="['/create-old-system-immo-project']"
  >
    + Uit oud systeem
  </button>

  <button
    *ngIf="selectedOverview === 'new' && !production"
    mat-flat-button
    class="action-button"
    (click)="openTestUnassignedExpiredSubProjectsModal()"
  >
    Test niet afgeklikte opdrachten naar niet uitgevoerd
  </button>

  <button
    *ngIf="selectedOverview === 'tasks'"
    mat-flat-button
    class="action-button"
    (click)="openCreateEditTaskModal()"
  >
    + Nieuwe taak
  </button>

  <button
    *ngIf="selectedOverview === 'new'"
    mat-flat-button
    class="action-button"
    [routerLink]="['/admin-project', 'nieuw', '0']"
  >
    + Nieuw IP bord
  </button>
</div>

<!--TABLES-->
<div>
  <new-immo-overview
    *ngIf="selectedOverview === 'new'"
    (countChange)="updateNewCount($event)"
  ></new-immo-overview>
  <immo-print-tables
    *ngIf="selectedOverview === 'print'"
    (countChange)="updatePrintCount($event)"
  ></immo-print-tables>
  <design-immo-overview
    *ngIf="selectedOverview === 'design'"
    (countChange)="updateDesignCount($event)"
  ></design-immo-overview>
  <appointment-immo-overview
    *ngIf="selectedOverview === 'appointment'"
    (countChange)="updateAppointmentCount($event)"
  ></appointment-immo-overview>
  <tour-page *ngIf="selectedOverview === 'tour'"></tour-page>
  <studio-immo-overview
    *ngIf="selectedOverview === 'atelier'"
    (countChange)="updateAtelierCount($event)"
  ></studio-immo-overview>
  <non-executed-immo-overview
    *ngIf="selectedOverview === 'non-executed'"
    (countChange)="updateNonExecutedCount($event)"
  ></non-executed-immo-overview>
  <delayed-immo-overview
    *ngIf="selectedOverview === 'delayed'"
    (countChange)="updateDelayedCount($event)"
  ></delayed-immo-overview>
  <immo-billing-overview
    *ngIf="selectedOverview === 'billing'"
    (countChange)="updateBillingCount($event)"
  ></immo-billing-overview>
  <completed-immo-overview
    *ngIf="selectedOverview === 'completed'"
    (countChange)="updateCompletedCount($event)"
  ></completed-immo-overview>
  <immo-task-overview
    *ngIf="selectedOverview === 'tasks'"
    [taskCreatedOrEdited]="taskCreatedOrEdited"
  ></immo-task-overview>
  <immo-job-overview *ngIf="selectedOverview === 'overview'">
  </immo-job-overview>
</div>
